import StandardRestError from './Standard'

class TrialReportUnavailableError extends StandardRestError {
  static CODE = 'TRIAL_REPORT_UNAVAILABLE'

  constructor(
    message = 'Reports are not part of the free trial.',
    status = 403,
    body = {},
  ) {
    super(message, status, body)
  }
}

export default TrialReportUnavailableError
